export default __webpack_public_path__ + "beta-maps-examples-user-location-view-960-f4a70113d6a3145c9906c0854e6a56bc.png";